/* eslint-disable */
export default {
  'statusEnabled_icon': 'EntityStatus_Active',
  'statusExcluded_icon': 'EntityStatus_Exclude',
  'statusDeleted_icon': 'EntityStatus_Deleted',
  'statusSuspended_icon': 'EntityStatus_InActive',
  'statusPaused_icon': 'EntityStatus_Paused'
};

